import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import Label from "@ingka/label";
const Switch = (props) => {
  const {
    id,
    prefix = "",
    describedById,
    value,
    name = "switchname",
    className,
    onChange,
    label,
    subtle = false,
    ...other
  } = props;
  const classes = cx(
    subtle && `${prefix}switch--subtle`,
    `${prefix}switch`,
    className
  );
  return /* @__PURE__ */ jsxs("span", { className: classes, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        id,
        type: "checkbox",
        name,
        value,
        className: `${prefix}switch__checkbox`,
        "aria-describedby": describedById,
        onChange,
        ...other
      }
    ),
    /* @__PURE__ */ jsx("span", { className: `${prefix}switch__toggle`, children: /* @__PURE__ */ jsx("span", { className: `${prefix}switch__button`, children: /* @__PURE__ */ jsx("span", { className: `${prefix}switch__symbol` }) }) }),
    label && /* @__PURE__ */ jsx(
      Label,
      {
        prefix,
        htmlFor: id,
        label,
        id: describedById,
        className: `${prefix}switch__label`
      }
    )
  ] });
};
var Switch_default = Switch;
export {
  Switch_default as default
};
